import React from 'react';
import * as FaIcons from 'react-icons/fa';
import '../styles/Blacklist.css'
import CallHistory from '../components/CallHistory';
import axios from 'axios'

class Calls extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            history: [],
            searchTerm: ''
        };
    }

    componentDidMount() {
        axios.get("http://safetel.ddns.net:5000/history?user_id=PROTOTYPE_USER_1")
        .then((response) => {
            this.setState({
                isLoaded: true,
                history: response.data.history
            })
        })
        .catch((error) => {
            this.setState({
                isLoaded: true,
                error
            })
        })
    }

    editSearchTerm = (e) => {
        this.setState({ searchTerm: e.target.value })
    }

    setCallTime = () => {
        return this.state.history.forEach(elem => {
            let date = new Date(elem.time) //convert to js time later (no miliseconds in unix time)
            let hours = date.getHours();
            let minutes = "0" + date.getMinutes();
            let seconds = "0" + date.getSeconds();
            let formattedTime = date.toLocaleDateString("en-UK") + " " + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
            elem.calltime = formattedTime
        })
    }

    setStatusIcon = () => {
        return this.state.history.forEach(elem => {
            if (elem.status === 'blocked') {
                elem.icon = <FaIcons.FaPhoneSlash className='blocked' />
                elem.status = ' blocked'
            } else if (elem.status === 'received') {
                elem.icon = <FaIcons.FaPhoneAlt className='passed' />
                elem.status = ' received'
            } else if (elem.status === 'whitelisted') {
                elem.icon = <FaIcons.FaPhone className='passed' />
                elem.status = ' whitelisted'
            }
        })
    }

    dynamicSearch = () => {
        return this.state.history.filter(history =>  {
            return history.number.includes(this.state.searchTerm)
        }).sort((a, b) => {
            return a.time - b.time
        })
    }

    render() {
        const { error, isLoaded} = this.state;
        if (error) {
            return (<div>Erreur : {error.message}</div>);
        } else if (!isLoaded) {
            return (<div>Chargement...</div>);
        } else {
            return (
                <div>
                    <h1 className="title">Journal d'appels</h1>
                    <div style={{ textAlign: 'center', paddingTop: '30vh' }}>
                        <input type='text' value={this.state.searchTerm} onChange={this.editSearchTerm} placeholder='chercher un numéro!' />
                        <br></br>
                        <br></br>
                        <CallHistory history={this.dynamicSearch(this.setStatusIcon(this.setCallTime()))} />
                    </div>
                </div>
            );
        }
    }
}

export default Calls;